module.exports = __webpack_public_path__ + "static/img/7_fun.1587c70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/7_fun.png
// module id = fvFj
// module chunks = 0